import { Alert, Typography } from '@mui/material'
import React, { useMemo } from 'react'

import { getFailedNodeDetails } from 'components/scenarios/utils/graph/nodes/get-failed-node-details'

import type { ScenarioRunResponse } from 'types/api/scenarios/runs/scenario-runs'
import type { Scenario } from 'types/api/scenarios/scenario'

export const ScenarioFailureAlert: React.FC<{
  run?: ScenarioRunResponse
  scenario: Pick<Scenario, 'graph'>
}> = ({ run, scenario }) => {
  const { graph } = run ?? scenario

  const reason = useMemo(() => {
    const failedReason =
      run?.stage_info?.stageMetadata?.failedReason ??
      run?.stage_info?.stageMetadata?.haltReason

    const haltSource = run?.stage_info?.stageMetadata?.haltSource

    return getFailedNodeDetails(graph, failedReason, haltSource)
  }, [graph, run?.stage_info?.stageMetadata])

  if (!reason) {
    return null
  }

  const hasNameOrType = reason.name || reason.type

  return (
    <Alert severity="error" sx={{ width: '100%' }}>
      {hasNameOrType && (
        <Typography variant="body2">
          Halted by{' '}
          {reason.type && (
            <Typography component="span" variant="body2">
              {reason.type}{' '}
            </Typography>
          )}
          {reason.name && (
            <Typography
              component="span"
              sx={{ fontWeight: 'bold' }}
              variant="body2"
            >
              {reason.name}
            </Typography>
          )}
        </Typography>
      )}
      {reason.message && (
        <Typography
          component="code"
          sx={{ fontFamily: 'monospace' }}
          variant="body2"
        >
          {reason.message}
        </Typography>
      )}
    </Alert>
  )
}
